module.exports = __webpack_public_path__ + "static/img/mini-banner4.aa6c4f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mini-banner4.png
// module id = GGnV
// module chunks = 0